import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Phone ergonomics: scroll to top on route change, and keep the focused field above the keyboard.
export default function MobileErgonomics() {
  const { pathname } = useLocation();
  useEffect(() => { if (!window.location.hash) window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => {
    if (!window.matchMedia("(max-width: 767px)").matches) return;
    const onFocus = (e) => {
      const el = e.target;
      if (!el.matches?.("input:not([type=checkbox]):not([type=radio]), textarea, select")) return;
      setTimeout(() => el.scrollIntoView({ block: "center", behavior: "smooth" }), 250);
    };
    document.addEventListener("focusin", onFocus);
    return () => document.removeEventListener("focusin", onFocus);
  }, []);
  return null;
}
